export default __webpack_public_path__ + "static/media/Fred.b46fb072.png";